// Объект с предопределенными цветами
export const colorObj: Record<string, string> = {
  white: '#FEFEFE',
  black: '#2A3034',
  darkgray: '#2E2D2B',
  darkbrown: '#4B3132',
  red: '#C64839',
  brickred: '#E36650',
  pumporange: '#E7894B',
  dryyellow: '#F1DB63',
  lemonjuiceyellow: '#F2E4B3',
  peagreen: '#A4B54D',
  denimblue: '#96AAC1',
  oldblue: '#768488',
};

export const colorObjFonts: Record<string, string> = {
  white: '#151514',
  black: '#FEFEFE',
  darkgray: '#FEFEFE',
  darkbrown: '#FEFEFE',
  red: '#FEFEFE',
  brickred: '#FEFEFE',
  pumporange: '#FEFEFE',
  dryyellow: '#151514',
  lemonjuiceyellow: '#151514',
  peagreen: '#151514',
  denimblue: '#151514',
  oldblue: '#151514',
};

/**
 * Функция для определения цвета текста на основе яркости фона
 */
export const invertColor = (
  bgColor: string,
  lightColor: string = 'white',
  darkColor: string = '#151514'
): string => {
  if (!bgColor) return darkColor;

  // Если цвет не в hex формате, возвращаем темный цвет по умолчанию
  const color = bgColor.charAt(0) === '#' ? bgColor.substring(1, 7) : bgColor;

  // Проверяем, что это валидный hex цвет
  if (!/^[0-9A-Fa-f]{6}$/.test(color)) {
    // Если это не hex, проверяем темные цвета
    const darkColors = ['black', 'darkgray', 'darkbrown', '#2A3034', '#2E2D2B', '#4B3132'];
    if (darkColors.includes(bgColor.toLowerCase())) {
      return lightColor;
    }
    return darkColor;
  }

  const r = parseInt(color.substring(0, 2), 16); // hexToR
  const g = parseInt(color.substring(2, 4), 16); // hexToG
  const b = parseInt(color.substring(4, 6), 16); // hexToB

  // Используем формулу яркости (luminance)
  // Если яркость > 186, используем темный текст, иначе светлый
  return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? darkColor : lightColor;
};

/**
 * Получает тему (white/black) на основе цвета фона
 */
export const getThemeByColor = (color: string): 'white' | 'black' => {
  if (!color) return 'white';
  const darkColors = ['black', 'darkgray', 'darkbrown', '#2A3034', '#2E2D2B', '#4B3132'];
  if (darkColors.includes(color.toLowerCase())) {
    return 'black';
  }
  // Проверяем hex цвет
  if (color.charAt(0) === '#') {
    const hex = color.substring(1, 7);
    if (!/^[0-9A-Fa-f]{6}$/.test(hex)) return 'white';
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const brightness = r * 0.299 + g * 0.587 + b * 0.114;
    return brightness > 186 ? 'white' : 'black';
  }
  return 'white';
};
// Объект с предопределенными цветами
export const colorObj: Record<string, string> = {
  white: '#FEFEFE',
  black: '#2A3034',
  darkgray: '#2E2D2B',
  darkbrown: '#4B3132',
  red: '#C64839',
  brickred: '#E36650',
  pumporange: '#E7894B',
  dryyellow: '#F1DB63',
  lemonjuiceyellow: '#F2E4B3',
  peagreen: '#A4B54D',
  denimblue: '#96AAC1',
  oldblue: '#768488',
};

export const colorObjFonts: Record<string, string> = {
  white: '#151514',
  black: '#FEFEFE',
  darkgray: '#FEFEFE',
  darkbrown: '#FEFEFE',
  red: '#FEFEFE',
  brickred: '#FEFEFE',
  pumporange: '#FEFEFE',
  dryyellow: '#151514',
  lemonjuiceyellow: '#151514',
  peagreen: '#151514',
  denimblue: '#151514',
  oldblue: '#151514',
};

/**
 * Функция для определения цвета текста на основе яркости фона
 */
export const invertColor = (
  bgColor: string,
  lightColor: string = 'white',
  darkColor: string = '#151514'
): string => {
  if (!bgColor) return darkColor;

  // Если цвет не в hex формате, возвращаем темный цвет по умолчанию
  const color = bgColor.charAt(0) === '#' ? bgColor.substring(1, 7) : bgColor;

  // Проверяем, что это валидный hex цвет
  if (!/^[0-9A-Fa-f]{6}$/.test(color)) {
    // Если это не hex, проверяем темные цвета
    const darkColors = ['black', 'darkgray', 'darkbrown', '#2A3034', '#2E2D2B', '#4B3132'];
    if (darkColors.includes(bgColor.toLowerCase())) {
      return lightColor;
    }
    return darkColor;
  }

  const r = parseInt(color.substring(0, 2), 16); // hexToR
  const g = parseInt(color.substring(2, 4), 16); // hexToG
  const b = parseInt(color.substring(4, 6), 16); // hexToB

  // Используем формулу яркости (luminance)
  // Если яркость > 186, используем темный текст, иначе светлый
  return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? darkColor : lightColor;
};

/**
 * Получает тему (white/black) на основе цвета фона
 */
export const getThemeByColor = (color: string): 'white' | 'black' => {
  if (!color) return 'white';
  const darkColors = ['black', 'darkgray', 'darkbrown', '#2A3034', '#2E2D2B', '#4B3132'];
  if (darkColors.includes(color.toLowerCase())) {
    return 'black';
  }
  // Проверяем hex цвет
  if (color.charAt(0) === '#') {
    const hex = color.substring(1, 7);
    if (!/^[0-9A-Fa-f]{6}$/.test(hex)) return 'white';
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const brightness = r * 0.299 + g * 0.587 + b * 0.114;
    return brightness > 186 ? 'white' : 'black';
  }
  return 'white';
};
